import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import PropTypes from "prop-types";
import EMPaymentForm from "../EMPaymentForm";
import "./index.scss";

const STRIPE_PK = process.env.REACT_APP_STRIPE_PUBLISHER_KEY;
const EMPaymentPage = ({ step, handleNext }) => {
  const [pk, setPk] = useState();
  const [stripePromise, setStripePromise] = useState(null);
  useEffect(() => {
    setTimeout(() => {
      setPk(STRIPE_PK);
    }, 1500);
  }, []);

  useEffect(() => {
    if (pk && !stripePromise) {
      setStripePromise(loadStripe(pk));
    }
  }, [pk, stripePromise]);
  return (
    <Elements stripe={stripePromise}>
      <EMPaymentForm step={step} handleNext={handleNext} />
    </Elements>
  );
};

EMPaymentPage.propTypes = {
  step: PropTypes.number,
  handleNext: PropTypes.func,
};

EMPaymentPage.defaultProps = {
  step: 1,
  handleNext: () => {},
};

export default EMPaymentPage;
